import { Injectable } from '@angular/core';

const dayOfMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const dataDate = {
  th: {
    month: [
      { fullName: 'มกราคม', shortName: 'ม.ค.' },
      { fullName: 'กุมภาพันธ์', shortName: 'ก.พ.' },
      { fullName: 'มีนาคม', shortName: 'มี.ค.' },
      { fullName: 'เมษายน', shortName: 'เม.ย.' },
      { fullName: 'พฤษภาคม', shortName: 'พ.ค.' },
      { fullName: 'มิถุนายน', shortName: 'มิ.ย.' },
      { fullName: 'กรกฎาคม', shortName: 'ก.ค.' },
      { fullName: 'สิงหาคม', shortName: 'ส.ค.' },
      { fullName: 'กันยายน', shortName: 'ก.ย.' },
      { fullName: 'ตุลาคม', shortName: 'ต.ค.' },
      { fullName: 'พฤศจิกายน', shortName: 'พ.ย.' },
      { fullName: 'ธันวาคม', shortName: 'ธ.ค.' },
    ],
    year: 543,
  },
  en: {
    month: [
      { fullName: 'January', shortName: 'Jan' },
      { fullName: 'February', shortName: 'Feb' },
      { fullName: 'March', shortName: 'Mar' },
      { fullName: 'April', shortName: 'Apr' },
      { fullName: 'May', shortName: 'May' },
      { fullName: 'June', shortName: 'Jun' },
      { fullName: 'July', shortName: 'Jul' },
      { fullName: 'August', shortName: 'Aug' },
      { fullName: 'September', shortName: 'Sep' },
      { fullName: 'October', shortName: 'Oct' },
      { fullName: 'November', shortName: 'Nov' },
      { fullName: 'December', shortName: 'Dec' },
    ],
    year: 0,
  },
};

// service
@Injectable({
  providedIn: 'root',
})
export class DateService {
  concatDateOfBirth(date: string, lang: string) {
    let dateOfBirth = date.split('-');
    const dateLang = lang === 'th' ? dataDate.th : dataDate.en;
    return (
      dateOfBirth[2] +
      ' ' +
      dateLang.month[Number(dateOfBirth[1]) - 1].shortName +
      ' ' +
      Number(Number(dateOfBirth[0]) + dateLang.year)
    );
  }

  findAge(date: string) {
    const birthDate = date.split('-');
    const birthDay = parseInt(birthDate[2]);
    const birthMonth = parseInt(birthDate[1]);
    const birthYear = parseInt(birthDate[0]);
    const currentDate: Date = new Date();

    let currentDay = currentDate.getDate();
    let currentMonth = currentDate.getMonth() + 1;
    let currentYear = currentDate.getFullYear();

    if (birthDay > currentDay) {
      currentDay = currentDay + dayOfMonth[birthMonth - 1];
      currentMonth = currentMonth - 1;
    }

    if (birthMonth > currentMonth) {
      currentYear = currentYear - 1;
      currentMonth = currentMonth + 12;
    }

    const resultDay = currentDay - birthDay;
    const resultMonth = currentMonth - birthMonth;
    const resultYear = currentYear - birthYear;
    const age = {
      year: resultYear,
      month: resultMonth,
      day: resultDay,
    };
    return age;
  }

  checkValidAge(ageY: number, ageM: number) {
    const validAge = 59;
    return ageY * 12 + ageM <= validAge * 12 ? true : false;
  }
}
